// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3TaYl","itemTitle":"ClientEmergencyInfo_itemTitle__RYLHB","itemText":"ClientEmergencyInfo_itemText__tawzf"};